import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65ae6bb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-lg-500px bg-secondary rounded shadow-sm p-10 p-lg-15 mx-auto",
  style: {"--bs-bg-opacity":"0.2"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold text-dark mb-3 text-center title" }, " ¿Olvidaste la contraseña? "),
  /*#__PURE__*/_createElementVNode("p", { class: "fs-base text-center" }, " Ingresa tu correo para reestablecer la contraseña ")
], -1))
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base fw-bold text-gray-900 fs-6" }, "Correo electrónico", -1))
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-5" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-at text-white fs-base" })
  ])
], -1))
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_10 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label fs-base fw-bold" }, " Enviar instrucciones de recuperación ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress fs-base" }, [
  /*#__PURE__*/_createTextVNode(" Enviando... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Form, {
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        onSubmit: _ctx.onSubmitForgotPassword,
        id: "kt_login_password_reset_form",
        "validation-schema": _ctx.forgotPassword
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid fs-base ps-13",
                type: "email",
                name: "email",
                autocomplete: "off",
                style: {"background":"none","border":"1px solid gray"}
              }),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ErrorMessage, { name: "email" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", _hoisted_10, _hoisted_13, 512)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createVNode(_component_router_link, {
      to: "/sign'in",
      class: "link-primary fs-sm mt-5 text-white"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Regresar al inicio ")
      ]),
      _: 1
    })
  ], 64))
}